// Converted from application/views/sculptures/index_v.php. Edit this component directly.
export default function SculpturesIndexPage() {
  return <><div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<a href={"/c/sculpture/wind&sea"}>
<img src={"/assets/images/sculptures/wind&sea/wind&sea-cover-full.jpg"} alt={"Wind & Sea"} />
</a>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Wind & Sea "}<small>{"(XL)"}</small></h1>
<h2>{"Bronze"}</h2>
<p class={"calltoaction"}><a href={"/c/sculpture/wind&sea"}><img src={"/icons/eye.svg"} alt={"learn more"} class={"iconEye"} />{" Learn more"}</a></p>
</div>
</div>
</div>
</div>
<div class={"firstContainer container photoRight"}>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Mother & Child"}</h1>
<h2>{"\n                    In Bronze\n                "}</h2>
<p class={"calltoaction"}><a href={"/c/sculpture/mother&child-bronze"}>
<img src={"/icons/eye.svg"} alt={"learn more"} class={"iconEye"} />{" Learn more"}</a></p>
<p class={"calltoaction"}><a href={"/c/sculpture/mother&child-story"}>
<img src={"/icons/book.svg"} alt={"read the story"} class={"iconBook"} />{" Read the story"}</a></p>
</div>
</div>
</div>
<figure class={"photo"}>
<a href={"/c/sculpture/mother&child-bronze"}>
<img src={"/assets/images/sculptures/mother&child/bronze/Mother&Child-Bronze-with-sculpture-paddy-campbell.jpg"} alt={"Paddy Campbell next to Mother & Child"} />
</a>
</figure>
</div>
<div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<a href={"/c/sculpture/blue-lady"}>
<img src={"/assets/images/sculptures/blue-lady/blue-lady-full.jpg"} alt={"Blue Lady"} />
</a>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Blue Lady"}</h1>
<h2>{"Bronze"}</h2>
<p class={"calltoaction"}><a href={"/c/sculpture/blue-lady"}><img src={"/icons/eye.svg"} alt={"learn more"} class={"iconEye"} />{" Learn more"}</a></p>
</div>
</div>
</div>
</div>
<div class={"firstContainer container photoRight"}>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Seven Veils "}<small>{"(L)"}</small></h1>
<h2>{"Bronze"}</h2>
<p class={"calltoaction"}><a href={"/c/sculpture/seven-veils"}><img src={"/icons/eye.svg"} alt={"learn more"} class={"iconEye"} />{" Learn more"}</a></p>
</div>
</div>
</div>
<figure class={"photo"}>
<a href={"/c/sculpture/seven-veils"}>
<img src={"/assets/images/sculptures/seven-veils/Seven-Veils-gold.jpg"} alt={"Seven Veils"} />
</a>
</figure>
</div>
<div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<a href={"/c/sculpture/la-vespa"}>
<img src={"/assets/images/sculptures/la-vespa/la-vespa-full.jpg"} alt={"La Vespa"} />
</a>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"La Vespa"}</h1>
<h2>{"Bronze"}</h2>
<p class={"calltoaction"}><a href={"/c/sculpture/la-vespa"}><img src={"/icons/eye.svg"} alt={"learn more"} class={"iconEye"} />{" Learn more"}</a></p>
</div>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<h1>{"\n                Fionnghuala "}<small>{"(M)"}</small>
</h1>
<h2>{"(Daughter of Lir)"}<br />{"Bronze"}</h2>
<p class={"calltoaction"}><a href={"/c/sculpture/fionnghuala"}>
<img src={"/icons/eye.svg"} alt={"learn more"} class={"iconEye"} />{" Learn more"}</a>
</p>
</div>
</div>
<figure class={"photo"}>
<a href={"/c/sculpture/fionnghuala"}>
<img src={"/assets/images/sculptures/fionnghuala/Fionnghuala-M.jpg"} alt="" />
</a>
</figure>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<h1>{"\n                Fionnghuala "}<small>{"(S)"}</small>
</h1>
<h2>{"(Daughter of Lir)"}<br />{"Bronze"}</h2>
<p class={"calltoaction"}><a href={"/c/sculpture/fionnghuala-s"}>
<img src={"/icons/eye.svg"} alt={"learn more"} class={"iconEye"} />{" Learn more"}</a>
</p>
</div>
</div>
<figure class={"photo"}>
<a href={"/c/sculpture/fionnghuala-s"}>
<img src={"/assets/images/milestones/Fionnghuala-Daughter-of-Lir-dublin.jpg"} alt="" />
</a>
</figure>
</div>
<div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<a href={"/c/sculpture/seven-veils-m"}>
<img src={"/assets/images/sculptures/seven-veils/seven-veils-medium.jpg"} alt={"Seven Veils (M)"} />
</a>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Seven Veils "}<small>{"(M)"}</small></h1>
<h2>{"Bronze"}</h2>
<p class={"calltoaction"}><a href={"/c/sculpture/seven-veils-m"}>
<img src={"/icons/eye.svg"} alt={"learn more"} class={"iconEye"} />{" Learn more"}</a>
</p>
</div>
</div>
</div>
</div>
<div class={"firstContainer container photoRight"}>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Wind & Sea "}<small>{"(M)"}</small></h1>
<h2>{"Bronze"}</h2>
<p class={"calltoaction"}>
<a href={"/c/sculpture/wind&sea-m"}>
<img src={"/icons/eye.svg"} alt={"learn more"} class={"iconEye"} />{" Learn more"}</a>
</p>
</div>
</div>
</div>
<figure class={"photo"}>
<a href={"/c/sculpture/wind&sea-m"}>
<img src={"/assets/images/sculptures/wind&sea/wind&sea-medium.jpg"} alt={"Wind & Sea (M)"} />
</a>
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/battle-dress/battle-dress-front.jpg"} alt={"Battle Dress"} />
</figure>
<div class={"text"}>
<div>
<h1>{"\n                Battle Dress "}<small>{"(L)"}</small>
</h1>
<p>{"\n                Ilaria dresses to show her defiance to those who failed to recognise her true value as a person.\n            "}</p>
<p>
<b>{"\n                    173 x 57 x 36 cm"}<br />{"\n                    68” x 22.5” x 14”"}<br />{"\n                    Bronze"}<br />{"\n                    No. in Series 7\n                "}</b>
</p>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<h1>{"\n                ALICE 1\n            "}</h1>
<p>{"\n                A moment of silence and solitude.\n            "}</p>
<p>
<b>{"\n                    34 x 34 x 21cm"}<br />{"\n                    13.4” x 13.4” x 8.2”"}<br />{"\n                    Bronze\n                "}</b>
</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/exhibitions/gormleys/Alice-1.jpg"} alt="" />
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/alice2/alice-mirror.jpg"} alt="" />
</figure>
<div class={"text"}>
<div>
<h1>{"\n                ALICE 2\n            "}</h1>
<p>{"\n                A childhood dream which never fades.... Alice in the looking glass."}<br />
<b>{"Note"}</b>{": Mirror is an extra sculpture by Paddy Campbell\n            "}</p>
<p>
<b>{"\n                    34 x 34 x 21cm"}<br />{"\n                    13.4” x 13.4” x 8.2”"}<br />{"\n                    Bronze\n                "}</b>
</p>
</div>
</div>
</div>
</>;
}
